module.exports = __webpack_public_path__ + "static/media/onboarding_3.994a989a.png";